import { Role } from '@/model/schema';
import VueRouter, { RouteConfig } from 'vue-router';
import RouterContainer from './router-container.vue';
import Home from '../views/home/home.vue';
import abilityAssessmentRoutes from './ability-assessment.routes';
import nuoxiaoerRoutes from './nuoxiaoer.routes';
import wecomVideoRoutes from './wecom-video.routes';
import bonusRoutes from './bonus.routes';
import massMessagingRoutes from './mass-messaging.routes';



const routes: RouteConfig[] = [
  // {
  //   path: '/',
  //   name: 'toBHome',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting this generates a separate chunk (about.[hash].js)
  //   //  for this route which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  // 诺小二AI
  ...nuoxiaoerRoutes,
  // 能力评估
  ...abilityAssessmentRoutes,
  // 诺华视界
  ...wecomVideoRoutes,
  // 口袋奖金
  ...bonusRoutes,
  // 群发消息
  ...massMessagingRoutes,
  {
    path: '/unauth',
    name: 'AuthErrorPage', // 权限错误
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/authErrorPage.vue'),
    // component: AuthErrorPage,
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: false,
      title: '权限错误',
      titleEn: 'Error Page'
    }
  },
  {
    path: '/manager',
    name: 'Manager', // 管理员管理
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/manager/manager.vue'),
    // component: Manager,
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '管理员管理',
      titleEn: 'Admin Management'
    }
  },
  {
    path: '/consent',
    name: 'Consent', // 隐私协议管理
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/consent/consent.vue'),
    // component: ConsentManager,
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '平台隐私协议',
      titleEn: 'Consent Management'
    }
  },
  {
    path: '/staffdataupload',
    name: 'staffdataupload', // 用户数据上传
    component: () =>
      import(
        /* webpackChunkName: "user" */ '../views/background-manage/staffdataupload.vue'
      ),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '员工数据上传',
      titleEn: 'User data upload'
    }
  },
  {
    path: '/sensitivewords',
    name: 'sensitivewords',
    component: () => import('../views/sensitivewords/sensitivewords.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '敏感词屏蔽',
      titleEn: 'Sensitive Words shield'
    }
  },
  {
    path: '/operationhistory',
    name: 'operationhistory', // 用户数据上传
    component: () =>
      import('../views/background-manage/operationhistory/index.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '操作历史查询',
      titleEn: 'User data upload'
    }
  },
  {
    path: '/usergroup',
    name: 'usergroup', // 用户分组
    component: () =>
      import(
        /* webpackChunkName: "userGroup" */ '../views/userGroup/userGroup.vue'
      ),
    // component: KeywordAnalysis,
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '用户分组',
      titleEn: 'User Group'
    }
  },
  {
    path: '/addresslist',
    name: 'addresslist',
    component: () => import('../views/addresslist/addressList.vue'),
    // component: KeywordAnalysis,
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '通讯录',
      titleEn: 'Address List'
    }
  },
  {
    path: '/hrcodelog',
    name: 'hrcodelog',
    component: () => import('../views/hrcodelog/hrcodelog.vue'),
    // component: KeywordAnalysis,
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: 'hrcode查询记录',
      titleEn: 'Address List'
    }
  },
  {
    path: '/pharmafield',
    name: 'pharmafield',
    component: () => import('../views/pharma-field-log/pharmafield.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: 'Pharma Field Force 同步',
      titleEn: 'Pharma Field Force Org Log'
    }
  },
  {
    path: '/oncologyfield',
    name: 'oncologyfield',
    component: () => import('../views/oncologyfieldlog/oncologyfield.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: 'Oconlogy Field Force 同步',
      titleEn: 'Oncology Field Force Org Log'
    }
  },
  {
    path: '/chatrecordcheck',
    name: 'chatrecordcheck',
    component: () => import('../views/chat-record-check/chatrecordcheck.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '聊天记录检查',
      titleEn: 'Chat record check'
    }
  },
  {
    path: '/externalcontacts',
    name: 'externalcontacts',
    component: () => import('../views/external-contacts/externalcontacts.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '外部联系人',
      titleEn: 'External contacts'
    }
  },
  // {
  //   path: '/unauthorizedExternalcontacts',
  //   name: 'unauthorizedExternalcontacts',
  //   component: () => import('../views/unauthorizedexternalcontacts/unauthorizedexternalcontacts.vue'),
  //   meta: {
  //     roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
  //     auth: true,
  //     title: '未验证外部联系人',
  //     titleEn: 'unauthoried External contacts'
  //   }
  // },
  {
    path: '/departureinheritanced',
    name: 'departureinheritanced',
    component: () => import('../views/departure-inheritanced/DepartureInheritanced.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '离职继承',
      titleEn: 'Departure inheritanced'
    }
  },
  {
    path: '/wechatMenu',
    name: '微信菜单',
    component: () => import('../views/wechatMenu/wechatMenu.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '微信菜单',
      titleEn: 'wechatMenu'
    }
  },
  {
    path: '/wechatReply',
    name: '自动回复',
    component: () => import('../views/wechatReply/wechatReply.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '自动回复',
      titleEn: 'wechatReply'
    }
  },
  {
    path: '/wechatImageText',
    name: '图文管理',
    component: () => import('../views/wechatImageText/wechatImageText.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '图文管理',
      titleEn: 'wechatImageText'
    }
  },
  {
    path: '/addImageText',
    name: '创建图文',
    component: () => import('../views/wechatImageText/addImageText.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '创建图文',
      titleEn: 'addImageText'
    }
  },
  {
    path: '/imageTextClassify',
    name: '图文分类',
    component: () => import('../views/wechatImageText/imageTextClassify.vue'),
    meta: {
      roles: [],
      auth: true,
      title: '图文分类',
      titleEn: 'imageTextClassify'
    }
  },
  {
    path: '/wechatPicture',
    name: '图片管理',
    component: () => import('../views/wechatPicture/wechatPicture.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '图片管理',
      titleEn: 'wechatMenu'
    }
  },
  {
    path: '/wechatFile',
    name: '文件管理',
    component: () => import('../views/wechatFile/wechatFile.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '文件管理',
      titleEn: 'wechatMenu'
    }
  },
  {
    path: '/wechatAudio',
    name: '音频管理',
    component: () => import('../views/wechatAudio/wechatAudio.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '音频管理',
      titleEn: 'wechatMenu'
    }
  },
  {
    path: '/wechatVideo',
    name: '视频管理',
    component: () => import('../views/wechatVideo/wechatVideo.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '视频管理',
      titleEn: 'wechatMenu'
    }
  },
  {
    path: '/advertPage',
    name: '应用开屏列表',
    component: () => import('../views/advertPage/advertPage.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '应用开屏列表',
      titleEn: 'advertPage'
    }
  },
  {
    path: '/advertApplication',
    name: '应用开屏',
    component: () => import('../views/advertPage/advertApplication.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '应用开屏',
      titleEn: 'advertPage'
    }
  },
  {
    path: '/permissionSon',
    name: 'permissionSon', // 权限设置
    component: () => import('../views/channel/permissions/apppermissions.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '应用权限',
      titleEn: 'permissionSon'
    }
  },
  {
    path: '/chatBook',
    name: '企微通讯录',
    component: () => import('../views/chatBook/chatBook.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '企微通讯录',
      titleEn: 'chatBook'
    }
  },
  {
    path: '/channel',
    // name: 'Channel', // 标签管理
    component: RouterContainer,
    // component: Tag,
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '标签管理',
      titleEn: 'User Group Management'
    },
    children: [
      {
        path: '',
        name: 'ChannelList', // 专栏
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/channel/channel.vue'
          ),
        // component: Channel,
        meta: {
          roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
          auth: true,
          title: '应用管理',
          titleEn: 'Applacation Management'
        }
      },
      {
        path: 'permissions',
        name: 'Permissions', // 权限设置
        component: () => import('../views/channel/permissions/permissions.vue'),
        meta: {
          roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
          auth: true,
          title: '权限设置',
          titleEn: 'Permissions'
        }
      },

      // {
      //   path: 'channelDetail',
      //   name: 'ChannelDetail', // 专栏
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "about" */ '../views/channel/channelDetailTab.vue'
      //     ),
      //   // component: ChannelDetail,
      //   meta: {
      //     roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      //     auth: true,
      //     title: '专栏管理',
      //     titleEn: 'Channel Management'
      //   },
      //   children: [
      //     {
      //       path: 'menu',
      //       name: 'MenuMain', // 专栏
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "about" */ '../views/channel/menu/menuMain.vue'
      //         ),
      //       // component: MenuMain,
      //       meta: {
      //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      //         auth: true,
      //         title: '专栏管理',
      //         titleEn: 'Channel Management'
      //       }
      //     },
      //     {
      //       path: 'reply',
      //       name: 'ReplyMain', // 专栏
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "about" */ '../views/channel/reply/replyMain.vue'
      //         ),
      //       // component: ReplyMain,
      //       meta: {
      //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      //         auth: true,
      //         title: '专栏管理',
      //         titleEn: 'Channel Management'
      //       }
      //     },
      //     {
      //       path: 'material',
      //       name: 'MaterialMain', // 专栏
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "about" */ '../components/material-selector/material/materialMain.vue'
      //         ),
      //       // component: MaterialMain,
      //       meta: {
      //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      //         auth: true,
      //         title: '专栏管理',
      //         titleEn: 'Channel Management'
      //       }
      //     },
      //     {
      //       path: 'message',
      //       name: 'MessageMain', // 专栏
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "about" */ '../views/channel/message/messageMain.vue'
      //         ),
      //       // component: MessageMain,
      //       meta: {
      //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      //         auth: true,
      //         title: '专栏管理',
      //         titleEn: 'Channel Management'
      //       }
      //     },
      //     {
      //       path: 'statistics',
      //       name: 'StatisticsMain', // 专栏
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "about" */ '../views/channel/statistics/statisticsMain.vue'
      //         ),
      //       // component: StatisticsMain,
      //       meta: {
      //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      //         auth: true,
      //         title: '专栏管理',
      //         titleEn: 'Channel Management'
      //       },
      //       children: [
      //         {
      //           path: 'pictureAnalysis',
      //           name: 'PictureAnalysis', // 专栏
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "about" */ '../views/channel/statistics/pictureAnalysis.vue'
      //             ),
      //           // component: PictureAnalysis,
      //           meta: {
      //             roles: [
      //               Role.SUPER_ADMIN,
      //               Role.DIGITAL_ADMIN,
      //               Role.CHANNEL_ADMIN
      //             ],
      //             auth: true,
      //             title: '专栏管理',
      //             titleEn: 'Channel Management'
      //           }
      //         },
      //         {
      //           path: 'userAnalysis',
      //           name: 'UserAnalysis', // 专栏
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "about" */ '../views/channel/statistics/userAnalysis.vue'
      //             ),
      //           // component: UserAnalysis,
      //           meta: {
      //             roles: [
      //               Role.SUPER_ADMIN,
      //               Role.DIGITAL_ADMIN,
      //               Role.CHANNEL_ADMIN
      //             ],
      //             auth: true,
      //             title: '专栏管理',
      //             titleEn: 'Channel Management'
      //           }
      //         },
      //         {
      //           path: 'applicationAnalysis',
      //           name: 'ApplicationAnalysis', // 专栏
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "about" */ '../views/channel/statistics/applicationAnalysis.vue'
      //             ),
      //           // component: ApplicationAnalysis,
      //           meta: {
      //             roles: [
      //               Role.SUPER_ADMIN,
      //               Role.DIGITAL_ADMIN,
      //               Role.CHANNEL_ADMIN
      //             ],
      //             auth: true,
      //             title: '专栏管理',
      //             titleEn: 'Channel Management'
      //           }
      //         },
      //         {
      //           path: 'keywordAnalysis',
      //           name: 'KeywordAnalysis', // 专栏
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "about" */ '../views/channel/statistics/keywordAnalysis.vue'
      //             ),
      //           // component: KeywordAnalysis,
      //           meta: {
      //             roles: [
      //               Role.SUPER_ADMIN,
      //               Role.DIGITAL_ADMIN,
      //               Role.CHANNEL_ADMIN
      //             ],
      //             auth: true,
      //             title: '专栏管理',
      //             titleEn: 'Channel Management'
      //           }
      //         },
      //         {
      //           path: 'historyAnalysis',
      //           name: 'HistoryAnalysis', // 专栏
      //           component: () =>
      //             import(
      //               /* webpackChunkName: "about" */ '../views/channel/statistics/historyAnalysis.vue'
      //             ),
      //           // component: HistoryAnalysis,
      //           meta: {
      //             roles: [
      //               Role.SUPER_ADMIN,
      //               Role.DIGITAL_ADMIN,
      //               Role.CHANNEL_ADMIN
      //             ],
      //             auth: true,
      //             title: '专栏管理',
      //             titleEn: 'Channel Management'
      //           }
      //         }
      //       ]
      //     }
      //   ]
      // }
    ]
  },
  // {
  //   path: '/keywordAdd',
  //   name: 'keywordAdd', // 专栏
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "about" */ '../views/channel/reply/keywordReplyAdd.vue'
  //     ),
  //   // component: keywordAdd,
  //   meta: {
  //     roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
  //     auth: true,
  //     title: '专栏管理',
  //     titleEn: 'Channel Management'
  //   }
  // },
  // {
  //   path: '/statistics',
  //   name: 'StatisticsMain', // 专栏
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "about" */ '../views/channel/statistics/statisticsMain.vue'
  //     ),
  //   // component: StatisticsMain,
  //   meta: {
  //     roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
  //     auth: true,
  //     title: '专栏管理',
  //     titleEn: 'Channel Management'
  //   },
  //   children: [
  //     {
  //       path: 'pictureAnalysis',
  //       name: 'PictureAnalysis', // 专栏
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/channel/statistics/pictureAnalysis.vue'
  //         ),
  //       // component: PictureAnalysis,
  //       meta: {
  //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
  //         auth: true,
  //         title: '专栏管理',
  //         titleEn: 'Channel Management'
  //       }
  //     },
  //     {
  //       path: 'userAnalysis',
  //       name: 'UserAnalysis', // 专栏
  //       // component: () => import(/* webpackChunkName: "about" */ '../views/channel/statistics/userAnalysis.vue')
  //       // component: UserAnalysis,
  //       meta: {
  //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
  //         auth: true,
  //         title: '专栏管理',
  //         titleEn: 'Channel Management'
  //       }
  //     },
  //     {
  //       path: 'applicationAnalysis',
  //       name: 'ApplicationAnalysis', // 专栏
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/channel/statistics/applicationAnalysis.vue'
  //         ),
  //       // component: ApplicationAnalysis,
  //       meta: {
  //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
  //         auth: true,
  //         title: '专栏管理',
  //         titleEn: 'Channel Management'
  //       }
  //     },
  //     {
  //       path: 'keywordAnalysis',
  //       name: 'KeywordAnalysis', // 专栏
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/channel/statistics/keywordAnalysis.vue'
  //         ),
  //       // component: KeywordAnalysis,
  //       meta: {
  //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
  //         auth: true,
  //         title: '专栏管理',
  //         titleEn: 'Channel Management'
  //       }
  //     },
  //     {
  //       path: 'historyAnalysis',
  //       name: 'HistoryAnalysis', // 专栏
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "about" */ '../views/channel/statistics/historyAnalysis.vue'
  //         ),
  //       // component: HistoryAnalysis,
  //       meta: {
  //         roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
  //         auth: true,
  //         title: '专栏管理',
  //         titleEn: 'Channel Management'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/simulate',
  //   name: 'Simulate', // 专栏
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/simulate/list.vue'),
  //   // component: Simulate,
  //   meta: {
  //     roles: [Role.SUPER_ADMIN],
  //     auth: true,
  //     title: '模拟用户',
  //     titleEn: 'Simulate Management'
  //   }
  // },
  // {
  //   path: '/CreateNewImageText',
  //   name: 'CreateNewImageText', // 创建新图文
  //   // component: () => import(/* webpackChunkName: "about" */ '../views/event/event.vue')
  //   component: () => import('../views/channel/material/material-items/createNewImageText.vue'),
  //   // component: CreateNewImageText,
  //   meta: {
  //     roles: ['1,2,3'],
  //     auth: true,
  //     title: '创建新图文',
  //     titleEn: 'Create New Image Text'
  //   }
  // },
  // {
  //   path: '/EditNewImageText',
  //   name: 'EditNewImageText', // 创建新图文
  //   component: () => import('../views/channel/material/material-items/editNewImageText.vue'),
  //   meta: {
  //     roles: ['1,2,3'],
  //     auth: true,
  //     title: '编辑图文',
  //     titleEn: 'Edit New Image Text'
  //   }
  // },
  // {
  //   path: '/SortImageText',
  //   name: 'SortImageText', // 图文分类
  //   component: () => import('../views/channel/message/sortImageText.vue'),
  //   meta: {
  //     roles: ['1,2,3'],
  //     auth: true,
  //     title: '图文分类',
  //     titleEn: 'Sort Image Text'
  //   }
  // },
  {
    //  数据分析  图文分析
    path: '/imgTextStatistics',
    name: 'imgTextStatistics',
    component: () => import('../views/statistics/imgTextStatistics.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '图文分析(平台)',
      titleEn: 'Img&Text Statistics'
    }
  },
  {
    //  数据分析 新 图文分析
    path: '/newImgText',
    name: 'newImgText',
    component: () => import('../views/statistics/newImgText.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '图文分析',
      titleEn: 'Img&Text Statistics'
    }
  },
  {
    //  数据分析  用户分析
    path: '/personStatistics',
    name: 'personStatistics',
    component: () => import('../views/statistics/personStatistics.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '用户分析',
      titleEn: 'User Statistics'
    }
  },
  {
    // 数据分析 专栏分析
    path: '/columnStatistics',
    name: 'columnStatistics',
    component: () => import('../views/statistics/columnStatistics.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '专栏分析',
      titleEn: 'User Statistics'
    }
  },
  {
    // 数据分析 关键字搜索分析
    path: '/keywordStatistics',
    name: 'keywordStatistics',
    component: () => import('../views/statistics/keywordStatistics.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: ' 关键字搜索分析',
      titleEn: 'Key Word Search Statistics'
    }
  },
  {
    //  数据分析 历史消息搜索分析
    path: '/historicalStatistics',
    name: 'historicalStatistics',
    component: () => import('../views/statistics/historicalStatistics.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '历史消息搜索分析',
      titleEn: 'Historical Statistics'
    }
  },
  {
    //  小诺密码服务
    path: '/resetpassword',
    name: 'resetpassword',
    component: () => import('../views/background-manage/paddword/reset.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '小诺密码服务',
      titleEn: 'Password Service'
    }
  },
  {
    path: '/mimanage',
    name: 'miManage',
    component: () => import('../views/background-manage/medicalinquiry/mimanage.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '医学问询管理',
      titleEn: 'MI-mimanage'
    }
  },
  {
    path: '/swiftlog',
    name: 'swiftLog',
    component: () => import('../views/background-manage/swift/log.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: 'Non FF日志',
      titleEn: 'Non FF'
    }
  },
  {
    path: '/roleplay',
    name: 'RolePlay',
    component: () => import('../views/application-fun-management/roleplay.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '配岗信息',
      titleEn: '配岗信息'
    }
  },
  {
    path: '/addProductMap',
    name: 'addProductMap', //个性化功能管理
    component: () =>
      import(/* webpackChunkName: "productMap" */ '../views/productMap/addProductMap.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '创建产品地图管理',
      titleEn: 'addProductMap'
    }
  },
  {
    path: '/productMap',
    name: 'productMap', //个性化功能管理
    component: () =>
      import(/* webpackChunkName: "productMap" */ '../views/productMap/productMap.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '产品地图管理',
      titleEn: 'productMap'
    }
  },
  {
    path: '/surveyTypeDictionary',
    name: 'surveyTypeDictionary', //问卷类型管理
    component: () =>
      import(/* webpackChunkName: "surveyTypeDictionary" */ '../views/surveyConfig/surveyTypeDictionary.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '远程助手类型管理',
      titleEn: 'surveyTypeDictionary'
    }
  },
  {
    path: '/surveyQuestionnaire',
    name: 'surveyQuestionnaire', //问卷管理
    component: () =>
      import(/* webpackChunkName: "surveyQuestionnaire" */ '../views/surveyConfig/surveyQuestionnaire.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '远程助手管理',
      titleEn: 'surveyQuestionnaire'
    }
  },
  {
    path: '/addSurvey',
    name: 'addSurvey',
    component: () =>
      import(/* webpackChunkName: "addSurvey" */ '../views/surveyConfig/addSurvey.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN],
      auth: true,
      title: '添加远程助手',
      titleEn: 'addSurvey'
    }
  },
];

export default routes;
